import { ClickAwayListener } from '@mui/material'
import React from 'react'

type MouseLeaveListenerProps = {
  onLeave: () => void
  leaveDelayMs?: number
  children?: React.ReactElement
}

export const MouseLeaveListener = (props: MouseLeaveListenerProps) => {
  const { onLeave, leaveDelayMs = 800 } = props
  const tid = React.useRef<number>()
  const onMouseLeave = React.useCallback(() => {
    tid.current = setTimeout(() => {
      onLeave()
    }, leaveDelayMs) as any
  }, [onLeave])
  const onMouseEnter = React.useCallback(() => {
    clearTimeout(tid.current)
  }, [onLeave])
  const child = React.cloneElement(props.children as any, { onMouseLeave, onMouseEnter })
  return <ClickAwayListener onClickAway={onLeave}>{child}</ClickAwayListener>
}
